"use client";

import PropTypes from "prop-types";
import classNames from "classnames";

import Loading from "components/common/loading-spinner";

import styles from "./styles.module.css";

const Button = ({
  children,
  buttonClass,
  size,
  disable,
  href,
  outline,
  shadow,
  isLoading,
  type = "button",
  blankTarget,
  ...props
}) => {
  const buttonClasses = classNames({
    [styles.btn]: true,
    [styles.sizeSmall]: size === "S",
    [styles.sizeMedium]: size === "M",
    [styles.sizeLarge]: size === "L",
    [styles.sizeAuto]: size === "Auto",
    [styles.disable]: disable,
    [styles.outline]: outline,
    [styles.shadow]: shadow,
    [styles.isLoading]: isLoading,
    [buttonClass]: buttonClass,
  });

  return href ? (
    <a
      href={href}
      target={blankTarget ? "_blank" : undefined}
      rel={blankTarget ? "noopener noreferrer" : undefined}
      className={styles.link}
    >
      <button type="button" className={buttonClasses} {...props}>
        {children}
      </button>
    </a>
  ) : (
    <button type={type} className={buttonClasses} disabled={isLoading} {...props}>
      {isLoading ? <Loading loadingClass={styles.loading} /> : children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.any,
  disable: PropTypes.bool,
  outline: PropTypes.bool,
  shadow: PropTypes.bool,
  href: PropTypes.string,
  buttonClass: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  type: PropTypes.string,
  blankTarget: PropTypes.bool,
};

export default Button;
